import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {
    Theme,
    Typography,
    Link,
    Breadcrumbs,
    Breakpoint,
    Container,
    Box,
} from '@mui/material';

import Page from 'components/Page';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
        },
        top: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            margin: theme.spacing(1),
        },
        section: {
            backgroundColor: theme.palette.common.neutralXXLight,
            margin: theme.spacing(1),
            padding: theme.spacing(1),
            minWidth: 300,
        },
        search: {
            width: '100%',
        },
    }),
);

interface PageProps {
    title?: string;
    breadcrumbs?: {
        text: string;
        link?: string;
    }[];
    children?: React.ReactNode;
    maxWidth?: false | Breakpoint;
}

const StandardPage: React.FunctionComponent<PageProps> = ({
    children,
    title,
    breadcrumbs,
    maxWidth,
}) => {
    const classes = useStyles();

    const brdcrumbs = breadcrumbs?.map((b) => {
        if (b.link)
            return (
                <Link
                    key={`${b.text}-${b.link}`}
                    color="inherit"
                    component={RouterLink}
                    to={b.link}
                >
                    {b.text}
                </Link>
            );

        return (
            <Typography key={b.text} color="textPrimary">
                {b.text}
            </Typography>
        );
    });

    return (
        <Page className={classes.root}>
            <Container maxWidth={maxWidth ?? false}>
                <Box className={classes.top}>
                    <Breadcrumbs>{brdcrumbs}</Breadcrumbs>
                    {title && (
                        <Typography variant="h5" color="textPrimary">
                            {title}
                        </Typography>
                    )}
                </Box>
                <Box sx={{ pt: 4, mb: 4, ml: 1 }}>{children}</Box>
            </Container>
        </Page>
    );
};

StandardPage.displayName = 'StandardPage';
export default StandardPage;
